'use client';

import useCarouselContext from 'components/shared/Carousel/CarouselContext';
import { useEffect } from 'react';
import { useAnimate } from 'motion/react';
import useCarouselIsPlaying from 'hooks/useCarouselIsPlaying';

const AutoplayProgressIndicator = ({ duration }: { duration: number }) => {
  const { api } = useCarouselContext();
  const { isPlaying } = useCarouselIsPlaying(api);
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const animation = animate(scope.current, { width: [0, 34] }, { duration });
    if (isPlaying) {
      animation.play();
    } else {
      animation.cancel();
    }
  }, [isPlaying, animate, scope, duration]);

  return (
    <div className="carousel-progress h-2.5 w-8.5 bg-(--pagination-timed-slide-default) rounded-full">
      <div ref={scope} className="h-full bg-(--pagination-timed-slide-active) rounded-full" />
    </div>
  );
};

export default AutoplayProgressIndicator;
